import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'dictName',
      type: 'input',
      label: '字典名称',
      rules: { required: true, message: '字典名称是必传的', trigger: 'blur' }
    },
    {
      field: 'dictCode',
      type: 'input',
      label: '字典编码',
      rules: { required: true, message: '字典编码是必传的', trigger: 'blur' }
    },
    {
      field: 'description',
      type: 'input',
      label: '描述'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
